

export function formatArabicDate(isoDate) {
  const date = new Date(isoDate);

  const dateFormatter = new Intl.DateTimeFormat('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const timeFormatter = new Intl.DateTimeFormat('ar-EG', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  });
  const formattedDate = dateFormatter.format(date);
  const formattedTime = timeFormatter.format(date);
  return `${formattedDate} الساعة ${formattedTime}`;
}

export function getPercentage(number1, number2) {
  if (number1 === 0) return 0;
  const percentage = (number2 / number1) * 100;
  return percentage > 100 ? 100 : percentage.toFixed(0);
}
